var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexagonBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 153.188,
    height: 188.222
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hexagon-badge_svg__c",
    x1: 1.005,
    y1: 0.502,
    x2: -0.005,
    y2: 0.502,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83a6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a78ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hexagon-badge_svg__a",
    x1: 0.999,
    y1: 0.486,
    x2: -0.012,
    y2: 0.486,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff66a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hexagon-badge_svg__d",
    x1: 0.502,
    y1: 1.037,
    x2: 0.502,
    y2: 0.463,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaeef9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#ced5e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hexagon-badge_svg__e",
    x1: 0.114,
    y1: 0.501,
    x2: 0.959,
    y2: 0.501,
    xlinkHref: "#hexagon-badge_svg__a"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "hexagon-badge_svg__b",
    x: 0,
    y: 0,
    width: 153.188,
    height: 188.222,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#657a93",
    floodOpacity: 0.18
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": 13
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M143.718 55.424v54.082a13.869 13.869 0 01-.144 2.439 19.674 19.674 0 01-9.816 14.776L86.699 153.69a19.619 19.619 0 01-14.728 2.008 20.543 20.543 0 01-5.2-2.008l-47.2-27.113a19.968 19.968 0 01-10.1-17.214V55.424a19.678 19.678 0 019.96-17.218l47.2-26.969a19.982 19.982 0 0114.872-2.003 25.8 25.8 0 015.2 2.008l47.054 26.964a20.041 20.041 0 019.96 17.214z",
    fill: "#eaeef9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M76.738 35.772l11.26-23.383",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.004 -.004)",
    filter: "url(#hexagon-badge_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M120.188 27.738v110.745a5.774 5.774 0 01-5.773 5.739h-75.64A5.774 5.774 0 0133 138.483V27.738A5.774 5.774 0 0138.775 22h75.64a5.773 5.773 0 015.773 5.738z",
    fill: "#3772ff"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M114.656 97.709h2.743v-2.725h-2.743zM114.656 92.217h2.743v-2.725h-2.743zM108.992 103.059h2.743v-2.725h-2.743zM108.992 97.709h2.743v-2.725h-2.743zM103.327 103.059h2.743v-2.725h-2.743zM103.327 97.709h2.743v-2.725h-2.743zM103.327 92.217h2.743v-2.725h-2.743zM97.807 103.059h2.743v-2.725h-2.743zM97.807 97.709h2.743v-2.725h-2.743zM97.807 92.217h2.743v-2.725h-2.743zM92.143 103.059h2.743v-2.725h-2.743zM92.143 97.709h2.743v-2.725h-2.743zM92.143 92.217h2.743v-2.725h-2.743zM86.478 103.059h2.743v-2.725h-2.743zM86.478 97.709h2.743v-2.725h-2.743zM86.478 92.217h2.743v-2.725h-2.743zM80.814 103.059h2.743v-2.725h-2.743zM80.814 97.709h2.743v-2.725h-2.743zM80.814 92.217h2.743v-2.725h-2.743z",
    fill: "#eaeef9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M0 2.727h2.743V0H0z",
    transform: "translate(75.15 100.325)",
    fill: "url(#hexagon-badge_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M75.149 97.709h2.743v-2.725h-2.743zM75.149 92.217h2.743v-2.725h-2.743zM69.485 103.059h2.743v-2.725h-2.743zM69.485 97.709h2.743v-2.725h-2.743z",
    fill: "#eaeef9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M0 2.727h2.743V0H0z",
    transform: "translate(69.521 89.566)",
    fill: "url(#hexagon-badge_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M63.822 103.059h2.743v-2.725h-2.743zM63.822 97.709h2.743v-2.725h-2.743zM63.822 92.217h2.743v-2.725h-2.743zM58.156 97.709h2.743v-2.725h-2.743z",
    fill: "#eaeef9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M58.156 92.217h2.743v-2.725h-2.743z",
    fill: "#f3f5fa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M52.637 103.059h2.743v-2.725h-2.743zM52.637 92.217h2.743v-2.725h-2.743zM46.973 103.059h2.743v-2.725h-2.743zM41.308 103.059h2.743v-2.725h-2.743zM41.308 97.709h2.743v-2.725h-2.743zM41.308 92.217h2.743v-2.725h-2.743zM35.644 103.059h2.743v-2.725h-2.743zM35.644 92.217h2.743v-2.725h-2.743zM76.595 41.366a6.025 6.025 0 10-6.063-6.024 6.044 6.044 0 006.063 6.024z",
    fill: "#eaeef9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 4598",
    fill: "#3772ff",
    d: "M33 41.367h87v63.099H33z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M76.446 35.772l-11.4-23.383",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M102.327 98.747a11.118 11.118 0 01-1.338 1.291 36.173 36.173 0 01-24.828 9.609 36.027 36.027 0 01-20.787-6.453c-1.732-1.147-3.32-1.581-4.764-3.016.723-1 2.165-1.721 5.053-2.868l1.155-.431c2.165-.86 5.341-2.761 9.239-4.338a3.066 3.066 0 001.3-1.4c.144-.287.433-.574.433-.86a2.829 2.829 0 00.288-1.578V81.39c-.144-.144-.144-.287-.288-.431a8.329 8.329 0 01-1.155-3.155l-.577-.287c-1.877.43-1.733-1.578-2.165-5.452-.145-1.578 0-1.865.721-2.152l.577-.86a19.223 19.223 0 01-2.021-8.033c0-3.586 1.588-6.025 3.753-7.172a14.892 14.892 0 01-1.156-3.301s7.651 1.291 10.249.718c3.321-.718 8.517.142 10.394 4.59.432.144.721.287 1.155.431a6.228 6.228 0 013.608 4.877c.433 3.443-1.443 7.172-1.876 8.75a.141.141 0 00.144.144c.577.287.723.718.433 2.152-.433 3.73-.289 5.882-2.165 5.451l-1.732 2.869c0 .287-.144.43-.144.716v8.178a2.253 2.253 0 00.465 1.375c.144.144.262.508.406.652a5.149 5.149 0 001.373 1.09c4.331 1.864 7.648 3.089 9.957 3.949a33.418 33.418 0 014.293 2.258z",
    fill: "#eaeef9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M90.018 72.209c-.433 3.73-.288 5.882-2.165 5.451l-1.732 2.869c0 .287-.144.43-.144.718v8.176h-8.372V56.286h10.1a6.232 6.232 0 013.609 4.877c.432 3.443-1.444 7.172-1.877 8.75a.141.141 0 00.144.144c.437.287.581.718.437 2.152z",
    fill: "#e3e7f5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M106.042 109.22c-6.5 6.025-20.209.574-29.881.574-7.651 0-23.673 6.025-29.592 2.008-1.155-.86.289-4.16.721-5.164a42.2 42.2 0 012.455-5.882c2.165-4.16 12.125-6.168 16.167-8.321a4.178 4.178 0 001.444-1.147 12 12 0 0019.342.143 5.181 5.181 0 001.444 1c.144 0 .288.144.433.144 13.424 5.451 14.291 4.733 16.023 9.754.288.865 2.022 6.316 1.444 6.891z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M106.042 109.221c-6.5 6.025-20.209.574-29.881.574-7.651 0-23.673 6.025-29.592 2.008-1.155-.86.289-4.16.721-5.164a42.2 42.2 0 012.455-5.883c2.165-4.159 12.125-6.168 16.167-8.32h.145a13.9 13.9 0 0022.374.144h.145c13.424 5.451 14.29 4.733 16.022 9.756.288.859 2.022 6.31 1.444 6.885z",
    fill: "#c1a086"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M89.297 69.913a6.812 6.812 0 00-.577-2.868c0-.144-.144-.287-.144-.431-1.444-2.869-4.764-4.16-7.8-4.3-7.939-.431-8.66 1.147-11.259-1.147.721 1.147.865 3.012-.289 5.308a6.166 6.166 0 01-3.9 2.725c-3.602-8.181-1.87-13.345 1.738-15.21a14.447 14.447 0 01-1.298-3.443s7.651 1.291 10.249.718c3.32-.718 8.516.142 10.393 4.59 3.175 1.291 4.475 3.3 4.763 5.451.577 3.441-1.443 7.173-1.876 8.607z",
    fill: "#1c3754"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M.289 8.176V.86C.144.718 0 .574 0 .431V0a4.567 4.567 0 001.588 1.721l5.773 4.017a3.528 3.528 0 004.62 0L17.323.86c.144-.143.432-.287.577-.574v7.6a2.12 2.12 0 00.144 1H.144c.145.008.145-.423.145-.71z",
    transform: "translate(67.933 80.816)",
    fill: "url(#hexagon-badge_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M120.188 103.339v35.145a5.774 5.774 0 01-5.773 5.739h-75.64A5.774 5.774 0 0133 138.484v-35.145z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M24.539 4.017H2.02A1.967 1.967 0 010 2.008 1.966 1.966 0 012.02 0h22.519a1.967 1.967 0 012.021 2.008 1.968 1.968 0 01-2.021 2.009z",
    transform: "translate(63.314 112.806)",
    fill: "url(#hexagon-badge_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M97.092 125.717H56.241a1.967 1.967 0 01-2.021-2.009 1.967 1.967 0 012.021-2.008h40.851a1.967 1.967 0 012.021 2.008 2.058 2.058 0 01-2.021 2.009zM84.679 134.755H68.656a1.29 1.29 0 01-1.3-1.292v-1.435a1.289 1.289 0 011.3-1.29h16.023a1.289 1.289 0 011.3 1.29v1.435a1.29 1.29 0 01-1.3 1.292z",
    fill: "#e3eaf2"
  }))));
}
export default SvgHexagonBadge;